import { ComponentProps } from '@stitches/react'
import { Button } from 'common/Button'
import { Icon } from 'common/Icon'
import { PopupDialogContent } from 'common/PopupDialog/PopupDialogContent'
import { SnackBar } from 'common/SnackBar'
import snackBar from 'common/SnackBar/config'
import { toast } from 'components/common/Toast'
import { ShareSocialType } from 'interfaces'
import { copyTextToClipboard } from 'lib/helpers'
import { Post } from 'models/Post'
import { Anchor } from 'primitives/Anchor'
import { Flex } from 'primitives/Flex'
import { List } from 'primitives/List'
import { ListItem } from 'primitives/ListItem'
import { Text } from 'primitives/Text'

export interface PostShareMenuProps extends ComponentProps<typeof Flex> {
  post: Post
  onShare?: (type: ShareSocialType) => void
}

export const PostShareMenu: React.FC<PostShareMenuProps> = ({ css, post, onShare }) => (
  <PopupDialogContent css={css}>
    <List
      type="grouped"
      css={{
        [`& ${ListItem}`]: {
          padding: '4px 5px',
          transition: '0.3s'
        },
        a: { width: '100%' },
        button: {
          padding: '8px',
          width: '100%',
          border: 0,
          gap: 10,
          textTransform: 'none',
          justifyContent: 'start'
        }
      }}
    >
      <ListItem>
        <Button
          onClick={async () => {
            await copyTextToClipboard(
              `https://${window.location.host}/post/${post.postId}/?utm_source=share-post&utm_medium=interface&utm_campaign=${post.profile?.username}`
            )
            toast('Copied link!')
            onShare?.('link')
          }}
        >
          <Icon icon="Link" />
          <Text type="body2" css={{ whiteSpace: 'nowrap', margin: '3px 5px' }}>
            Copy link
          </Text>
        </Button>
      </ListItem>

      <ListItem>
        <Anchor
          href={`https://www.facebook.com/share.php?u=https://${window.location.host}/post/${post.postId}`}
          target="_blank"
          rel="noreferrer"
          onClick={() => onShare?.('facebook')}
          nounderline
        >
          <Button>
            <Icon icon="Facebook" css={{ transform: 'scale(0.7)' }} />
            <Text type="body2" css={{ whiteSpace: 'nowrap' }}>
              Facebook
            </Text>
          </Button>
        </Anchor>
      </ListItem>
      {/* <Button round theme='secondary'>
        <Icon icon='Instagram' css={{ transform: 'scale(0.7)' }} />
      </Button> */}
      <ListItem>
        <Anchor
          href={`https://twitter.com/intent/tweet?url=https://${window.location.host}/post/${post.postId}`}
          target="_blank"
          onClick={() => onShare?.('twitter')}
          nounderline
        >
          <Button>
            <Icon icon="Twitter" css={{ transform: 'scale(0.7)' }} />
            <Text type="body2" css={{ whiteSpace: 'nowrap' }}>
              Twitter
            </Text>
          </Button>
        </Anchor>
      </ListItem>
    </List>
  </PopupDialogContent>
)
